module.exports = __webpack_public_path__ + "static/media/phone.5889c932.svg";